import { connect } from 'react-redux';

import Confirmation from './view';

export default connect(state => ({ flow: state.flow }), {})(Confirmation);
